// GA4 is loaded as gtag.js directly in public/index.html, and only initialized when
// REACT_APP_ENVIRONMENT is production -- outside of it, window.gtag is not wired up.
const GA4_ENABLED = process.env.REACT_APP_ENVIRONMENT === 'production'

// GA4's automatic click tracking only listens for real <a href> clicks. The three sign-up cards
// build their destination in JS and navigate programmatically, so the click has to be reported by
// hand, before the navigation runs.
//
// Beacon transport is what makes it survive: the coach card sets window.location.href immediately,
// which would cancel an in-flight XHR before it left the browser.
export const trackSignUpPathSelected = (segment) => {
  if (!GA4_ENABLED) {
    console.log(`[GA4] Skipped (Not in production): signup_segment "${segment}"`) // eslint-disable-line no-console
    return
  }

  if (typeof window.gtag !== 'function') { return }

  window.gtag('event', 'select_content', {
    content_type: 'signup_segment',
    segment,
    transport_type: 'beacon',
  })
}
